import React from 'react';
import { CreditCard, Shield, Users, TrendingUp, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const ComeFunziona = () => {
  const steps = [
    {
      icon: Users,
      title: 'Attiva la consulenza',
      description: 'Il servizio VeCo Shop è riservato a tutti coloro che hanno aderito tramite richiesta online o direttamente presso i VeCo Point.',
      color: 'text-teal-600',
      bgColor: 'bg-teal-50'
    },
    {
      icon: CreditCard,
      title: 'Ritira la tua tessera',
      description: 'Recati presso uno dei VeCo Point per ritirare gratuitamente la tua tessera fisica. Porta con te un documento di identità.',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    },
    {
      icon: TrendingUp,
      title: 'Cerca le attività convenzionate',
      description: 'Utilizza il sistema di ricerca per trovare attività convenzionate nella tua zona. Esplora le offerte e gli sconti riservati.',
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      icon: CheckCircle2,
      title: 'Presenta la tessera prima del pagamento',
      description: 'IMPORTANTE: Dichiara di avere la tessera VeCo e mostrala PRIMA di effettuare il pagamento per ottenere lo sconto riservato.',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50'
    }
  ];

  return (
    <section id="come-funziona" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Come funziona
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Scopri come accedere al circuito di vantaggi esclusivi VeCo Shop Community in 4 semplici passi
            </p>
          </div>

          {/* Steps */}
          <div className="space-y-6">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <Card key={index} className="border-2 border-gray-100 hover:border-teal-200 transition-all duration-300 hover:shadow-lg">
                  <CardContent className="p-8">
                    <div className="flex items-start space-x-6">
                      {/* Step Number & Icon */}
                      <div className="flex-shrink-0">
                        <div className={`w-16 h-16 rounded-full ${step.bgColor} flex items-center justify-center relative`}>
                          <Icon className={`w-8 h-8 ${step.color}`} />
                          <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center text-sm font-bold">
                            {index + 1}
                          </div>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="flex-1">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">
                          {step.title}
                        </h3>
                        <p className="text-gray-700 leading-relaxed">
                          {step.description}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          {/* Important Notice */}
          <div className="mt-12 bg-gradient-to-r from-red-50 to-orange-50 border-l-4 border-red-500 rounded-lg p-6">
            <div className="flex items-start">
              <Shield className="w-6 h-6 text-red-600 mr-4 flex-shrink-0 mt-1" />
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">Attenzione importante</h4>
                <p className="text-gray-700 leading-relaxed">
                  La tessera VeCo è <strong>gratuita</strong> e ti apre le porte del circuito VeCo Shop.<br />
Per le attività convenzionate, il servizio è <strong>completamente incluso</strong> con un contratto di consulenza attivo presso il VeCo Point.<br />
In alternativa, puoi aderire al circuito con un costo di soli <strong>€ 0,40 al giorno</strong>, tramite <strong>contratto annuale</strong>, continuando a ottenere visibilità, nuovi clienti e vantaggi esclusivi.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};